import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "mot-panel" }
const _hoisted_2 = {
  key: 0,
  class: "mot-top"
}
const _hoisted_3 = {
  key: 0,
  class: "mot-new-form"
}
const _hoisted_4 = { class: "mot-grid" }
const _hoisted_5 = { class: "mot-field mot-field-wide" }
const _hoisted_6 = { class: "mot-field" }
const _hoisted_7 = { class: "mot-field" }
const _hoisted_8 = { class: "mot-field mot-field-wide" }
const _hoisted_9 = { class: "mot-field mot-field-wide" }
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  key: 0,
  class: "mot-chips"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "mot-items-form" }
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  class: "mot-error"
}
const _hoisted_18 = { class: "mot-form-actions" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 1,
  class: "mot-loading"
}
const _hoisted_21 = {
  key: 2,
  class: "mot-empty"
}
const _hoisted_22 = {
  key: 3,
  class: "mot-list"
}
const _hoisted_23 = { class: "mot-type-header" }
const _hoisted_24 = { class: "mot-type-heading" }
const _hoisted_25 = { class: "mot-type-title" }
const _hoisted_26 = { class: "mot-type-sub" }
const _hoisted_27 = { class: "mot-type-actions" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "mot-type-status" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = {
  key: 2,
  class: "mot-flag mot-flag-pending"
}
const _hoisted_34 = {
  key: 3,
  class: "mot-flag mot-flag-ok"
}
const _hoisted_35 = {
  key: 4,
  class: "mot-flag"
}
const _hoisted_36 = { class: "mot-type-instances" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 0,
  class: "mot-new-form"
}
const _hoisted_39 = { class: "mot-grid" }
const _hoisted_40 = { class: "mot-field mot-field-wide" }
const _hoisted_41 = { class: "mot-field" }
const _hoisted_42 = { class: "mot-field" }
const _hoisted_43 = { class: "mot-field mot-field-wide" }
const _hoisted_44 = { class: "mot-form-actions" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = {
  key: 1,
  class: "mot-new-form"
}
const _hoisted_47 = { class: "mot-grid" }
const _hoisted_48 = { class: "mot-field mot-field-wide" }
const _hoisted_49 = ["value"]
const _hoisted_50 = {
  key: 0,
  class: "mot-chips"
}
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { class: "mot-field" }
const _hoisted_53 = { class: "mot-field mot-field-wide" }
const _hoisted_54 = { class: "mot-check-row" }
const _hoisted_55 = {
  key: 0,
  class: "mot-error"
}
const _hoisted_56 = {
  key: 1,
  class: "mot-success"
}
const _hoisted_57 = { class: "mot-form-actions" }
const _hoisted_58 = ["disabled", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MaintenanceOSInstanceDetail = _resolveComponent("MaintenanceOSInstanceDetail")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.selectedOsId)
      ? (_openBlock(), _createBlock(_component_MaintenanceOSInstanceDetail, {
          key: 0,
          "os-id": _ctx.selectedOsId,
          "access-level": _ctx.accessLevel,
          onBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedOsId = '')),
          onChanged: _ctx.reload
        }, null, 8, ["os-id", "access-level", "onChanged"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.accessLevel >= 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("button", {
                  class: "mot-btn mot-btn-primary",
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCreateForm = !_ctx.showCreateForm))
                }, _toDisplayString(_ctx.showCreateForm ? 'Fechar formulário' : '+ Requisitar OS'), 1),
                (_ctx.showCreateForm)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _cache[18] || (_cache[18] = _createElementVNode("label", { class: "mot-label" }, "Título da OS", -1)),
                          _withDirectives(_createElementVNode("input", {
                            class: "mot-input",
                            type: "text",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.createForm.title) = $event)),
                            placeholder: "Ex.: Manutenção elétrica — bloco B"
                          }, null, 512), [
                            [_vModelText, _ctx.createForm.title]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                          _cache[20] || (_cache[20] = _createElementVNode("label", { class: "mot-label" }, "Prioridade", -1)),
                          _withDirectives(_createElementVNode("select", {
                            class: "mot-select",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.createForm.priority) = $event))
                          }, [...(_cache[19] || (_cache[19] = [
                            _createElementVNode("option", { value: "baixa" }, "Baixa", -1),
                            _createElementVNode("option", { value: "normal" }, "Normal", -1),
                            _createElementVNode("option", { value: "alta" }, "Alta", -1),
                            _createElementVNode("option", { value: "urgente" }, "Urgente", -1)
                          ]))], 512), [
                            [_vModelSelect, _ctx.createForm.priority]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _cache[21] || (_cache[21] = _createElementVNode("label", { class: "mot-label" }, "Prazo", -1)),
                          _withDirectives(_createElementVNode("input", {
                            class: "mot-input",
                            type: "date",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.createForm.dueDate) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.createForm.dueDate]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _cache[22] || (_cache[22] = _createElementVNode("label", { class: "mot-label" }, "Descrição", -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            class: "mot-textarea",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.createForm.description) = $event)),
                            rows: "2"
                          }, null, 512), [
                            [_vModelText, _ctx.createForm.description]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _cache[24] || (_cache[24] = _createElementVNode("label", { class: "mot-label" }, [
                            _createTextVNode("Responsáveis "),
                            _createElementVNode("span", { class: "mot-hint" }, "— o primeiro que concluir um item já vale para todos")
                          ], -1)),
                          _withDirectives(_createElementVNode("select", {
                            class: "mot-select",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.respPick) = $event)),
                            onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.addResponsavel && _ctx.addResponsavel(...args)))
                          }, [
                            _cache[23] || (_cache[23] = _createElementVNode("option", { value: "" }, "— Adicionar responsável —", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userOptions, (u) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: u.username,
                                value: u.username
                              }, _toDisplayString(u.name), 9, _hoisted_10))
                            }), 128))
                          ], 544), [
                            [_vModelSelect, _ctx.respPick]
                          ]),
                          (_ctx.createForm.responsavelUserIds.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.createForm.responsavelUserIds, (uid) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: uid,
                                    class: "mot-chip"
                                  }, [
                                    _createTextVNode(_toDisplayString(_ctx.userNameOf(uid)) + " ", 1),
                                    _createElementVNode("button", {
                                      class: "mot-chip-x",
                                      type: "button",
                                      onClick: ($event: any) => (_ctx.removeResponsavel(uid))
                                    }, "×", 8, _hoisted_12)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _cache[25] || (_cache[25] = _createElementVNode("div", { class: "mot-section-label" }, "Rotinas desta OS", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.createForm.items, (item, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: idx,
                            class: "mot-item-row"
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              class: "mot-input",
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((item.title) = $event),
                              placeholder: "Título da rotina"
                            }, null, 8, _hoisted_14), [
                              [_vModelText, item.title]
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              class: "mot-input",
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((item.description) = $event),
                              placeholder: "Descrição (opcional)"
                            }, null, 8, _hoisted_15), [
                              [_vModelText, item.description]
                            ]),
                            _createElementVNode("button", {
                              class: "mot-chip-x",
                              type: "button",
                              onClick: ($event: any) => (_ctx.removeCreateItem(idx))
                            }, "×", 8, _hoisted_16)
                          ]))
                        }), 128)),
                        _createElementVNode("button", {
                          class: "mot-btn",
                          type: "button",
                          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.addCreateItem && _ctx.addCreateItem(...args)))
                        }, "+ Adicionar rotina")
                      ]),
                      (_ctx.createError)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.createError), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("button", {
                          class: "mot-btn mot-btn-primary",
                          type: "button",
                          disabled: _ctx.creating,
                          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.submitCreate && _ctx.submitCreate(...args)))
                        }, _toDisplayString(_ctx.creating ? 'Requisitando...' : 'Requisitar OS'), 9, _hoisted_19)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Carregando..."))
            : (_ctx.typeGroups.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, "Nenhuma OS encontrada para este projeto."))
              : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeGroups, (group) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: group.rootId,
                      class: "mot-type-card"
                    }, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, _toDisplayString(group.title), 1),
                          _createElementVNode("div", _hoisted_26, _toDisplayString(group.instances.length) + " " + _toDisplayString(group.instances.length > 1 ? 'instâncias' : 'instância'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          (_ctx.accessLevel >= 2)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "mot-btn",
                                type: "button",
                                onClick: ($event: any) => (_ctx.toggleEditType(group))
                              }, _toDisplayString(_ctx.editingType === group.rootId ? 'Fechar' : 'Editar'), 9, _hoisted_28))
                            : _createCommentVNode("", true),
                          (_ctx.accessLevel >= 2)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "mot-btn mot-btn-primary",
                                type: "button",
                                onClick: ($event: any) => (_ctx.toggleDesignateType(group.rootId))
                              }, _toDisplayString(_ctx.designatingType === group.rootId ? 'Fechar' : 'Requisitar OS'), 9, _hoisted_29))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        (group.lastCompletedAt)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, "Preenchida pela última vez em " + _toDisplayString(_ctx.formatDateTime(group.lastCompletedAt)) + _toDisplayString(group.lastCompletedByName ? ` por ${group.lastCompletedByName}` : ''), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_32, "Ainda não preenchida")),
                        (group.newestHasPending)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_33, "⚠ Pendente de preenchimento"))
                          : (group.newestApproved)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_34, "✓ Aprovada"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_35, "Aguardando revisão"))
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.instances, (inst) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: inst.id,
                            class: "mot-instance-chip",
                            type: "button",
                            onClick: ($event: any) => (_ctx.selectedOsId = inst.id)
                          }, [
                            _createTextVNode(" OS" + _toDisplayString(inst.osNumber) + " ", 1),
                            _createElementVNode("span", {
                              class: _normalizeClass(["mot-status-badge", 's-' + inst.status])
                            }, _toDisplayString(_ctx.statusLabel(inst.status)), 3)
                          ], 8, _hoisted_37))
                        }), 128))
                      ]),
                      (_ctx.editingType === group.rootId)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("div", _hoisted_40, [
                                _cache[26] || (_cache[26] = _createElementVNode("label", { class: "mot-label" }, "Título", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  class: "mot-input",
                                  type: "text",
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.editTypeForm.title) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.editTypeForm.title]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_41, [
                                _cache[28] || (_cache[28] = _createElementVNode("label", { class: "mot-label" }, "Prioridade", -1)),
                                _withDirectives(_createElementVNode("select", {
                                  class: "mot-select",
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.editTypeForm.priority) = $event))
                                }, [...(_cache[27] || (_cache[27] = [
                                  _createElementVNode("option", { value: "baixa" }, "Baixa", -1),
                                  _createElementVNode("option", { value: "normal" }, "Normal", -1),
                                  _createElementVNode("option", { value: "alta" }, "Alta", -1),
                                  _createElementVNode("option", { value: "urgente" }, "Urgente", -1)
                                ]))], 512), [
                                  [_vModelSelect, _ctx.editTypeForm.priority]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_42, [
                                _cache[29] || (_cache[29] = _createElementVNode("label", { class: "mot-label" }, "Prazo", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  class: "mot-input",
                                  type: "date",
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.editTypeForm.dueDate) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.editTypeForm.dueDate]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_43, [
                                _cache[30] || (_cache[30] = _createElementVNode("label", { class: "mot-label" }, "Descrição", -1)),
                                _withDirectives(_createElementVNode("textarea", {
                                  class: "mot-textarea",
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.editTypeForm.description) = $event)),
                                  rows: "2"
                                }, null, 512), [
                                  [_vModelText, _ctx.editTypeForm.description]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_44, [
                              _createElementVNode("button", {
                                class: "mot-btn mot-btn-primary",
                                type: "button",
                                onClick: ($event: any) => (_ctx.submitEditType(group.rootId))
                              }, "Salvar", 8, _hoisted_45)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.designatingType === group.rootId)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, [
                              _createElementVNode("div", _hoisted_48, [
                                _cache[32] || (_cache[32] = _createElementVNode("label", { class: "mot-label" }, "Responsáveis", -1)),
                                _withDirectives(_createElementVNode("select", {
                                  class: "mot-select",
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.designatePick) = $event)),
                                  onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.addDesignateResponsavel && _ctx.addDesignateResponsavel(...args)))
                                }, [
                                  _cache[31] || (_cache[31] = _createElementVNode("option", { value: "" }, "— Adicionar responsável —", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userOptions, (u) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: u.username,
                                      value: u.username
                                    }, _toDisplayString(u.name), 9, _hoisted_49))
                                  }), 128))
                                ], 544), [
                                  [_vModelSelect, _ctx.designatePick]
                                ]),
                                (_ctx.designateForm.responsavelUserIds.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.designateForm.responsavelUserIds, (uid) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: uid,
                                          class: "mot-chip"
                                        }, [
                                          _createTextVNode(_toDisplayString(_ctx.userNameOf(uid)) + " ", 1),
                                          _createElementVNode("button", {
                                            class: "mot-chip-x",
                                            type: "button",
                                            onClick: ($event: any) => (_ctx.removeDesignateResponsavel(uid))
                                          }, "×", 8, _hoisted_51)
                                        ]))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_52, [
                                _cache[33] || (_cache[33] = _createElementVNode("label", { class: "mot-label" }, "Prazo", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  class: "mot-input",
                                  type: "date",
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.designateForm.dueDate) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.designateForm.dueDate]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_53, [
                                _createElementVNode("label", _hoisted_54, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.designateForm.requireAll) = $event))
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.designateForm.requireAll]
                                  ]),
                                  _cache[34] || (_cache[34] = _createTextVNode(" Todos precisam preencher (cria uma OS separada por pessoa) ", -1))
                                ])
                              ])
                            ]),
                            (_ctx.designateError)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_55, _toDisplayString(_ctx.designateError), 1))
                              : _createCommentVNode("", true),
                            (_ctx.designateResult)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_56, _toDisplayString(_ctx.designateResult), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_57, [
                              _createElementVNode("button", {
                                class: "mot-btn mot-btn-primary",
                                type: "button",
                                disabled: _ctx.designating,
                                onClick: ($event: any) => (_ctx.submitDesignate(group.rootId))
                              }, _toDisplayString(_ctx.designating ? 'Requisitando...' : 'Requisitar OS'), 9, _hoisted_58)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
        ], 64))
  ]))
}